module.exports = __webpack_public_path__ + "images/Vitals_SS_108646973_225a2c5.jpg";